import React, { useState } from 'react';
import { Page, PageHead, PageTitle } from '../components/ui/Page';
import { Kicker } from '../components/ui/Kicker';
import { Icon } from '../components/ui/Icon';

const FAQS: [string, string][] = [
  [
    'How does pricing work?',
    'Almaship aggregates live rates from 24+ carriers. You pay the carrier price plus a small platform fee (typically 3–5%). No monthly minimums, no subscription.',
  ],
  [
    'What countries do you ship to?',
    '40+ countries across MENA, Europe, Asia, and North America. Full list in your dashboard when you quote a shipment.',
  ],
  [
    'How does the wallet work?',
    'Top up once in any supported currency. We auto-convert at market rates when you book in another currency. No hidden FX spreads.',
  ],
  [
    'Is insurance included?',
    'Yes — $100 of coverage is included on every shipment. You can upgrade to declared value at checkout.',
  ],
  [
    'Do you support API?',
    'Yes, REST + webhooks. Create labels, sync to Shopify/WooCommerce, receive tracking updates. Docs at developers.almaship.co.',
  ],
  [
    'How long do shipments take?',
    'Domestic: same-day to 3 days. International express: 1–3 days. Standard international: 3–7 days. You see exact ETAs before booking.',
  ],
  [
    'Can I schedule pickups?',
    'Yes — most carriers offer pickup for $2–5. Or drop off at any partner location.',
  ],
  [
    'What about customs?',
    'For international shipments we generate customs paperwork automatically. You provide HS codes and declared value; we do the rest.',
  ],
];

const FAQPage: React.FC = () => {
  const [open, setOpen] = useState<number>(-1);

  const toggle = (i: number) => setOpen((prev) => (prev === i ? -1 : i));

  return (
    <Page width="narrow">
      <PageHead>
        <div>
          <Kicker>FAQ</Kicker>
          <PageTitle style={{ marginTop: 8 }}>Frequently asked questions</PageTitle>
        </div>
      </PageHead>

      <div className="card" style={{ overflow: 'hidden' }}>
        {FAQS.map(([q, a], i) => (
          <div
            key={i}
            style={{ borderBottom: i < FAQS.length - 1 ? '1px solid var(--line)' : 'none' }}
          >
            <button
              onClick={() => toggle(i)}
              style={{
                width: '100%',
                padding: '18px 24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: 15,
                fontWeight: 500,
                color: 'var(--ink)',
                textAlign: 'left',
                fontFamily: 'inherit',
              }}
            >
              {q}
              <Icon name={open === i ? 'minus' : 'plus'} size={16} />
            </button>
            {open === i && (
              <div
                style={{
                  padding: '0 24px 20px',
                  color: 'var(--ink-2)',
                  fontSize: 14,
                  lineHeight: 1.6,
                }}
              >
                {a}
              </div>
            )}
          </div>
        ))}
      </div>
    </Page>
  );
};

export default FAQPage;
